import React from 'react'

import { DefaultMediaWizardLayout } from './DefaultMediaWizardLayout'

import { MediaAcademyAdmin as MediaAcademyAdminComponent } from 'components/MediaAcademy'
import { Breadcrumb } from 'components/Links'

import { useDocumentTitle } from '@percept/hooks'


const breadcrumbs: Breadcrumb[] = [
  {
    path: '/wizard/optimisation',
    name: 'Optimisation',
  },
  {
    path: '/wizard/optimisation/media-academy',
    name: 'Media Academy',
  },
  {
    path: '/wizard/optimisation/media-academy/admin',
    name: 'Admin',
  },
]


export const MediaAcademyAdmin = (): JSX.Element => {
  useDocumentTitle({ paths: ['Optimisation', 'Media Academy', 'Admin'] })
  return (
    <DefaultMediaWizardLayout
      breadcrumbs={breadcrumbs}>

      <MediaAcademyAdminComponent />

    </DefaultMediaWizardLayout>
  )
}
